export default __webpack_public_path__ + "static/char-thumb-12-e7e1ef9d561042ef5f896a92a5064fd1.png";